import React from "react";
import { useInput, InputProps } from "react-admin";
import DaysCheckBoxGroup from "./DaysCheckBoxGroup";

const DaysCheckBoxInput: React.FC<InputProps> = (props) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useInput(props);

  // Ensure value is always an array (default empty)
  const checkedValues = Array.isArray(value) ? value : [];

  return (
    <>
      <DaysCheckBoxGroup value={checkedValues} onChange={onChange} />
      {error && <p style={{ color: "red" }}>{error.message}</p>}
    </>
  );
};

export default DaysCheckBoxInput;
